/**
 * 与ECA计算相关的函数
 */
import _ from 'lodash'
import * as esriLoader from 'esri-loader'
import distanceUtil from './distanceUtil'
const ecaPolysArr = [
  {
    name: 'North America West',
    data: [
      {
        lat: '32-32-10-N',
        lon: '117-06-11-W',
        wt: '0'
      },
      {
        lat: '32-32-04-N',
        lon: '117-07-29-W',
        wt: '0'
      },
      {
        lat: '32-31-39-N',
        lon: '117-14-20-W',
        wt: '0'
      },
      {
        lat: '32-33-13-N',
        lon: '117-15-50-W',
        wt: '0'
      },
      {
        lat: '32-34-21-N',
        lon: '117-22-01-W',
        wt: '0'
      },
      {
        lat: '32-35-23-N',
        lon: '117-27-53-W',
        wt: '0'
      },
      {
        lat: '32-37-38-N',
        lon: '117-49-34-W',
        wt: '0'
      },
      {
        lat: '31-07-59-N',
        lon: '118-36-21-W',
        wt: '0'
      },
      {
        lat: '30-33-25-N',
        lon: '121-47-29-W',
        wt: '0'
      },
      {
        lat: '31-46-11-N',
        lon: '123-17-22-W',
        wt: '0'
      },
      {
        lat: '32-21-58-N',
        lon: '123-50-44-W',
        wt: '0'
      },
      {
        lat: '32-56-39-N',
        lon: '124-11-47-W',
        wt: '0'
      },
      {
        lat: '33-40-12-N',
        lon: '124-27-15-W',
        wt: '0'
      },
      {
        lat: '34-31-28-N',
        lon: '125-16-52-W',
        wt: '0'
      },
      {
        lat: '35-14-38-N',
        lon: '125-43-23-W',
        wt: '0'
      },
      {
        lat: '35-43-60-N',
        lon: '126-18-53-W',
        wt: '0'
      },
      {
        lat: '36-16-25-N',
        lon: '126-45-30-W',
        wt: '0'
      },
      {
        lat: '37-01-35-N',
        lon: '127-07-18-W',
        wt: '0'
      },
      {
        lat: '37-45-39-N',
        lon: '127-38-02-W',
        wt: '0'
      },
      {
        lat: '38-25-08-N',
        lon: '127-52-60-W',
        wt: '0'
      },
      {
        lat: '39-25-05-N',
        lon: '128-31-23-W',
        wt: '0'
      },
      {
        lat: '40-18-47-N',
        lon: '128-45-46-W',
        wt: '0'
      },
      {
        lat: '41-13-39-N',
        lon: '128-40-22-W',
        wt: '0'
      },
      {
        lat: '42-12-49-N',
        lon: '129-00-38-W',
        wt: '0'
      },
      {
        lat: '42-47-34-N',
        lon: '129-05-42-W',
        wt: '0'
      },
      {
        lat: '43-26-22-N',
        lon: '129-01-26-W',
        wt: '0'
      },
      {
        lat: '44-24-43-N',
        lon: '128-41-23-W',
        wt: '0'
      },
      {
        lat: '45-30-43-N',
        lon: '128-40-02-W',
        wt: '0'
      },
      {
        lat: '46-11-01-N',
        lon: '128-49-01-W',
        wt: '0'
      },
      {
        lat: '46-33-55-N',
        lon: '129-04-29-W',
        wt: '0'
      },
      {
        lat: '47-39-55-N',
        lon: '131-15-41-W',
        wt: '0'
      },
      {
        lat: '48-32-32-N',
        lon: '132-41-00-W',
        wt: '0'
      },
      {
        lat: '48-57-47-N',
        lon: '133-14-47-W',
        wt: '0'
      },
      {
        lat: '49-22-39-N',
        lon: '134-15-51-W',
        wt: '0'
      },
      {
        lat: '50-01-52-N',
        lon: '135-19-01-W',
        wt: '0'
      },
      {
        lat: '51-03-18-N',
        lon: '136-45-45-W',
        wt: '0'
      },
      {
        lat: '51-54-04-N',
        lon: '137-41-54-W',
        wt: '0'
      },
      {
        lat: '52-45-12-N',
        lon: '138-20-14-W',
        wt: '0'
      },
      {
        lat: '53-29-20-N',
        lon: '138-40-36-W',
        wt: '0'
      },
      {
        lat: '53-40-39-N',
        lon: '138-48-53-W',
        wt: '0'
      },
      {
        lat: '54-13-45-N',
        lon: '139-32-38-W',
        wt: '0'
      },
      {
        lat: '54-39-25-N',
        lon: '139-56-19-W',
        wt: '0'
      },
      {
        lat: '55-20-18-N',
        lon: '140-55-45-W',
        wt: '0'
      },
      {
        lat: '56-07-12-N',
        lon: '141-36-18-W',
        wt: '0'
      },
      {
        lat: '56-28-32-N',
        lon: '142-17-19-W',
        wt: '0'
      },
      {
        lat: '56-37-19-N',
        lon: '142-48-57-W',
        wt: '0'
      },
      {
        lat: '58-51-04-N',
        lon: '153-15-03-W',
        wt: '0'
      }
    ]
  },
  {
    name: 'North America East',
    data: [
      {
        lat: '60-00-00-N',
        lon: '64-09-36-W',
        wt: '11'
      },
      {
        lat: '60-00-00-N',
        lon: '56-43-00-W',
        wt: '11'
      },
      {
        lat: '58-54-01-N',
        lon: '55-38-05-W',
        wt: '0'
      },
      {
        lat: '57-50-52-N',
        lon: '55-03-47-W',
        wt: '0'
      },
      {
        lat: '57-35-13-N',
        lon: '54-00-59-W',
        wt: '0'
      },
      {
        lat: '57-14-20-N',
        lon: '53-07-58-W',
        wt: '0'
      },
      {
        lat: '56-48-09-N',
        lon: '52-23-29-W',
        wt: '0'
      },
      {
        lat: '56-18-13-N',
        lon: '51-49-42-W',
        wt: '0'
      },
      {
        lat: '54-23-21-N',
        lon: '50-17-44-W',
        wt: '0'
      },
      {
        lat: '53-44-54-N',
        lon: '50-07-17-W',
        wt: '0'
      },
      {
        lat: '53-04-59-N',
        lon: '50-10-05-W',
        wt: '0'
      },
      {
        lat: '52-20-06-N',
        lon: '49-57-09-W',
        wt: '0'
      },
      {
        lat: '51-34-20-N',
        lon: '48-52-45-W',
        wt: '0'
      },
      {
        lat: '50-40-15-N',
        lon: '48-16-04-W',
        wt: '0'
      },
      {
        lat: '50-02-28-N',
        lon: '48-07-03-W',
        wt: '0'
      },
      {
        lat: '49-24-03-N',
        lon: '48-09-35-W',
        wt: '0'
      },
      {
        lat: '48-39-22-N',
        lon: '47-55-17-W',
        wt: '0'
      },
      {
        lat: '47-24-25-N',
        lon: '47-46-56-W',
        wt: '0'
      },
      {
        lat: '46-35-12-N',
        lon: '48-00-54-W',
        wt: '0'
      },
      {
        lat: '45-19-45-N',
        lon: '48-43-28-W',
        wt: '0'
      },
      {
        lat: '44-43-38-N',
        lon: '49-16-50-W',
        wt: '0'
      },
      {
        lat: '44-16-38-N',
        lon: '49-51-23-W',
        wt: '0'
      },
      {
        lat: '43-53-15-N',
        lon: '50-34-01-W',
        wt: '0'
      },
      {
        lat: '43-36-06-N',
        lon: '51-20-41-W',
        wt: '0'
      },
      {
        lat: '43-23-59-N',
        lon: '52-17-22-W',
        wt: '0'
      },
      {
        lat: '43-19-50-N',
        lon: '53-20-13-W',
        wt: '0'
      },
      {
        lat: '43-21-14-N',
        lon: '54-09-20-W',
        wt: '0'
      },
      {
        lat: '43-29-41-N',
        lon: '55-07-41-W',
        wt: '0'
      },
      {
        lat: '42-40-12-N',
        lon: '55-31-44-W',
        wt: '0'
      },
      {
        lat: '41-58-19-N',
        lon: '56-09-34-W',
        wt: '0'
      },
      {
        lat: '41-20-21-N',
        lon: '57-05-13-W',
        wt: '0'
      },
      {
        lat: '40-55-34-N',
        lon: '58-02-55-W',
        wt: '0'
      },
      {
        lat: '40-41-38-N',
        lon: '59-05-18-W',
        wt: '0'
      },
      {
        lat: '40-38-33-N',
        lon: '60-12-20-W',
        wt: '0'
      },
      {
        lat: '40-45-46-N',
        lon: '61-14-03-W',
        wt: '0'
      },
      {
        lat: '41-04-52-N',
        lon: '62-17-49-W',
        wt: '0'
      },
      {
        lat: '40-36-55-N',
        lon: '63-10-49-W',
        wt: '0'
      },
      {
        lat: '40-17-32-N',
        lon: '64-08-37-W',
        wt: '0'
      },
      {
        lat: '40-07-32-N',
        lon: '64-59-31-W',
        wt: '0'
      },
      {
        lat: '40-05-44-N',
        lon: '65-53-07-W',
        wt: '0'
      },
      {
        lat: '39-58-05-N',
        lon: '65-59-51-W',
        wt: '0'
      },
      {
        lat: '39-28-24-N',
        lon: '66-21-14-W',
        wt: '0'
      },
      {
        lat: '39-01-54-N',
        lon: '66-48-33-W',
        wt: '0'
      },
      {
        lat: '38-39-16-N',
        lon: '67-20-59-W',
        wt: '0'
      },
      {
        lat: '38-19-20-N',
        lon: '68-02-01-W',
        wt: '0'
      },
      {
        lat: '38-05-29-N',
        lon: '68-46-55-W',
        wt: '0'
      },
      {
        lat: '37-58-14-N',
        lon: '69-34-07-W',
        wt: '0'
      },
      {
        lat: '37-57-47-N',
        lon: '70-24-09-W',
        wt: '0'
      },
      {
        lat: '37-52-46-N',
        lon: '70-37-50-W',
        wt: '0'
      },
      {
        lat: '37-18-37-N',
        lon: '71-08-33-W',
        wt: '0'
      },
      {
        lat: '36-32-25-N',
        lon: '71-33-59-W',
        wt: '0'
      },
      {
        lat: '35-34-58-N',
        lon: '71-26-02-W',
        wt: '0'
      },
      {
        lat: '34-33-10-N',
        lon: '71-37-04-W',
        wt: '0'
      },
      {
        lat: '33-54-49-N',
        lon: '71-52-35-W',
        wt: '0'
      },
      {
        lat: '33-19-23-N',
        lon: '72-17-12-W',
        wt: '0'
      },
      {
        lat: '32-45-31-N',
        lon: '72-54-05-W',
        wt: '0'
      },
      {
        lat: '31-55-13-N',
        lon: '74-12-02-W',
        wt: '0'
      },
      {
        lat: '31-27-14-N',
        lon: '75-15-20-W',
        wt: '0'
      },
      {
        lat: '31-03-16-N',
        lon: '75-51-18-W',
        wt: '0'
      },
      {
        lat: '30-45-42-N',
        lon: '76-31-38-W',
        wt: '0'
      },
      {
        lat: '30-12-48-N',
        lon: '77-18-29-W',
        wt: '0'
      },
      {
        lat: '29-25-17-N',
        lon: '76-56-42-W',
        wt: '0'
      },
      {
        lat: '28-36-59-N',
        lon: '76-47-60-W',
        wt: '0'
      },
      {
        lat: '28-17-13-N',
        lon: '76-40-10-W',
        wt: '0'
      },
      {
        lat: '28-17-12-N',
        lon: '79-11-23-W',
        wt: '0'
      },
      {
        lat: '27-52-56-N',
        lon: '79-28-35-W',
        wt: '0'
      },
      {
        lat: '27-26-01-N',
        lon: '79-31-38-W',
        wt: '0'
      },
      {
        lat: '27-16-13-N',
        lon: '79-34-18-W',
        wt: '0'
      },
      {
        lat: '27-11-54-N',
        lon: '79-34-56-W',
        wt: '0'
      },
      {
        lat: '27-05-59-N',
        lon: '79-35-19-W',
        wt: '0'
      },
      {
        lat: '27-00-28-N',
        lon: '79-35-17-W',
        wt: '0'
      },
      {
        lat: '26-55-16-N',
        lon: '79-34-39-W',
        wt: '0'
      },
      {
        lat: '26-53-58-N',
        lon: '79-34-27-W',
        wt: '0'
      },
      {
        lat: '26-45-46-N',
        lon: '79-32-41-W',
        wt: '0'
      },
      {
        lat: '26-44-30-N',
        lon: '79-32-23-W',
        wt: '0'
      },
      {
        lat: '26-43-40-N',
        lon: '79-32-20-W',
        wt: '0'
      },
      {
        lat: '26-41-12-N',
        lon: '79-32-01-W',
        wt: '0'
      },
      {
        lat: '26-38-13-N',
        lon: '79-31-32-W',
        wt: '0'
      },
      {
        lat: '26-36-30-N',
        lon: '79-31-06-W',
        wt: '0'
      },
      {
        lat: '26-35-21-N',
        lon: '79-30-50-W',
        wt: '0'
      },
      {
        lat: '26-34-51-N',
        lon: '79-30-46-W',
        wt: '0'
      },
      {
        lat: '26-34-11-N',
        lon: '79-30-38-W',
        wt: '0'
      },
      {
        lat: '26-31-12-N',
        lon: '79-30-15-W',
        wt: '0'
      },
      {
        lat: '26-29-05-N',
        lon: '79-29-53-W',
        wt: '0'
      },
      {
        lat: '26-25-31-N',
        lon: '79-29-58-W',
        wt: '0'
      },
      {
        lat: '26-23-29-N',
        lon: '79-29-55-W',
        wt: '0'
      },
      {
        lat: '26-23-21-N',
        lon: '79-29-54-W',
        wt: '0'
      },
      {
        lat: '26-18-57-N',
        lon: '79-31-55-W',
        wt: '0'
      },
      {
        lat: '26-15-26-N',
        lon: '79-33-17-W',
        wt: '0'
      },
      {
        lat: '26-15-13-N',
        lon: '79-33-23-W',
        wt: '0'
      },
      {
        lat: '26-08-09-N',
        lon: '79-35-53-W',
        wt: '0'
      },
      {
        lat: '26-07-47-N',
        lon: '79-36-09-W',
        wt: '0'
      },
      {
        lat: '26-06-59-N',
        lon: '79-36-35-W',
        wt: '0'
      },
      {
        lat: '26-02-52-N',
        lon: '79-38-22-W',
        wt: '0'
      },
      {
        lat: '25-59-30-N',
        lon: '79-40-03-W',
        wt: '0'
      },
      {
        lat: '25-59-16-N',
        lon: '79-41-08-W',
        wt: '0'
      },
      {
        lat: '25-57-48-N',
        lon: '79-40-38-W',
        wt: '0'
      },
      {
        lat: '25-56-18-N',
        lon: '79-41-06-W',
        wt: '0'
      },
      {
        lat: '25-54-04-N',
        lon: '79-41-38-W',
        wt: '0'
      },
      {
        lat: '25-53-24-N',
        lon: '79-41-46-W',
        wt: '0'
      },
      {
        lat: '25-51-54-N',
        lon: '79-41-59-W',
        wt: '0'
      },
      {
        lat: '25-49-33-N',
        lon: '79-42-16-W',
        wt: '0'
      },
      {
        lat: '25-48-24-N',
        lon: '79-42-23-W',
        wt: '0'
      },
      {
        lat: '25-48-20-N',
        lon: '79-42-24-W',
        wt: '0'
      },
      {
        lat: '25-46-26-N',
        lon: '79-42-44-W',
        wt: '0'
      },
      {
        lat: '25-46-16-N',
        lon: '79-42-45-W',
        wt: '0'
      },
      {
        lat: '25-43-40-N',
        lon: '79-42-59-W',
        wt: '0'
      },
      {
        lat: '25-42-31-N',
        lon: '79-42-48-W',
        wt: '0'
      },
      {
        lat: '25-40-37-N',
        lon: '79-42-27-W',
        wt: '0'
      },
      {
        lat: '25-37-24-N',
        lon: '79-42-27-W',
        wt: '0'
      },
      {
        lat: '25-37-08-N',
        lon: '79-42-27-W',
        wt: '0'
      },
      {
        lat: '25-31-03-N',
        lon: '79-42-12-W',
        wt: '0'
      },
      {
        lat: '25-27-59-N',
        lon: '79-42-11-W',
        wt: '0'
      },
      {
        lat: '25-24-04-N',
        lon: '79-42-12-W',
        wt: '0'
      },
      {
        lat: '25-22-21-N',
        lon: '79-42-20-W',
        wt: '0'
      },
      {
        lat: '25-21-29-N',
        lon: '79-42-08-W',
        wt: '0'
      },
      {
        lat: '25-16-52-N',
        lon: '79-41-24-W',
        wt: '0'
      },
      {
        lat: '25-15-57-N',
        lon: '79-41-31-W',
        wt: '0'
      },
      {
        lat: '25-10-39-N',
        lon: '79-41-31-W',
        wt: '0'
      },
      {
        lat: '25-09-51-N',
        lon: '79-41-36-W',
        wt: '0'
      },
      {
        lat: '25-09-03-N',
        lon: '79-41-45-W',
        wt: '0'
      },
      {
        lat: '25-03-55-N',
        lon: '79-42-29-W',
        wt: '0'
      },
      {
        lat: '25-02-60-N',
        lon: '79-42-56-W',
        wt: '0'
      },
      {
        lat: '25-00-30-N',
        lon: '79-44-05-W',
        wt: '0'
      },
      {
        lat: '24-59-03-N',
        lon: '79-44-48-W',
        wt: '0'
      },
      {
        lat: '24-55-28-N',
        lon: '79-45-57-W',
        wt: '0'
      },
      {
        lat: '24-44-18-N',
        lon: '79-49-24-W',
        wt: '0'
      },
      {
        lat: '24-43-04-N',
        lon: '79-49-38-W',
        wt: '0'
      },
      {
        lat: '24-42-36-N',
        lon: '79-50-50-W',
        wt: '0'
      },
      {
        lat: '24-41-47-N',
        lon: '79-52-57-W',
        wt: '0'
      },
      {
        lat: '24-38-32-N',
        lon: '79-59-58-W',
        wt: '0'
      },
      {
        lat: '24-36-27-N',
        lon: '80-03-51-W',
        wt: '0'
      },
      {
        lat: '24-33-18-N',
        lon: '80-12-43-W',
        wt: '0'
      },
      {
        lat: '24-33-05-N',
        lon: '80-13-21-W',
        wt: '0'
      },
      {
        lat: '24-32-13-N',
        lon: '80-15-16-W',
        wt: '0'
      },
      {
        lat: '24-31-27-N',
        lon: '80-17-47-W',
        wt: '0'
      },
      {
        lat: '24-30-14-N',
        lon: '80-19-21-W',
        wt: '0'
      },
      {
        lat: '24-30-06-N',
        lon: '80-19-44-W',
        wt: '0'
      },
      {
        lat: '24-29-38-N',
        lon: '80-21-05-W',
        wt: '0'
      },
      {
        lat: '24-28-18-N',
        lon: '80-24-35-W',
        wt: '0'
      },
      {
        lat: '24-28-06-N',
        lon: '80-25-10-W',
        wt: '0'
      },
      {
        lat: '24-27-23-N',
        lon: '80-27-20-W',
        wt: '0'
      },
      {
        lat: '24-26-30-N',
        lon: '80-29-30-W',
        wt: '0'
      },
      {
        lat: '24-25-07-N',
        lon: '80-32-22-W',
        wt: '0'
      },
      {
        lat: '24-23-30-N',
        lon: '80-36-09-W',
        wt: '0'
      },
      {
        lat: '24-22-33-N',
        lon: '80-38-56-W',
        wt: '0'
      },
      {
        lat: '24-22-07-N',
        lon: '80-39-51-W',
        wt: '0'
      },
      {
        lat: '24-19-31-N',
        lon: '80-45-21-W',
        wt: '0'
      },
      {
        lat: '24-19-16-N',
        lon: '80-45-47-W',
        wt: '0'
      },
      {
        lat: '24-18-38-N',
        lon: '80-46-49-W',
        wt: '0'
      },
      {
        lat: '24-18-35-N',
        lon: '80-46-54-W',
        wt: '0'
      },
      {
        lat: '24-09-51-N',
        lon: '80-59-47-W',
        wt: '0'
      },
      {
        lat: '24-09-48-N',
        lon: '80-59-51-W',
        wt: '0'
      },
      {
        lat: '24-08-58-N',
        lon: '81-01-07-W',
        wt: '0'
      },
      {
        lat: '24-08-30-N',
        lon: '81-01-51-W',
        wt: '0'
      },
      {
        lat: '24-08-26-N',
        lon: '81-01-57-W',
        wt: '0'
      },
      {
        lat: '24-07-28-N',
        lon: '81-03-06-W',
        wt: '0'
      },
      {
        lat: '24-02-20-N',
        lon: '81-09-05-W',
        wt: '0'
      },
      {
        lat: '23-59-60-N',
        lon: '81-11-16-W',
        wt: '0'
      },
      {
        lat: '23-55-32-N',
        lon: '81-12-55-W',
        wt: '0'
      },
      {
        lat: '23-53-52-N',
        lon: '81-19-43-W',
        wt: '0'
      },
      {
        lat: '23-50-52-N',
        lon: '81-29-59-W',
        wt: '0'
      },
      {
        lat: '23-50-02-N',
        lon: '81-39-59-W',
        wt: '0'
      },
      {
        lat: '23-49-05-N',
        lon: '81-49-59-W',
        wt: '0'
      },
      {
        lat: '23-49-05-N',
        lon: '82-00-11-W',
        wt: '0'
      },
      {
        lat: '23-49-42-N',
        lon: '82-09-59-W',
        wt: '0'
      },
      {
        lat: '23-51-14-N',
        lon: '82-24-59-W',
        wt: '0'
      },
      {
        lat: '23-51-14-N',
        lon: '82-39-59-W',
        wt: '0'
      },
      {
        lat: '23-49-42-N',
        lon: '82-48-53-W',
        wt: '0'
      },
      {
        lat: '23-49-32-N',
        lon: '82-51-11-W',
        wt: '0'
      },
      {
        lat: '23-49-24-N',
        lon: '82-59-59-W',
        wt: '0'
      },
      {
        lat: '23-49-52-N',
        lon: '83-14-59-W',
        wt: '0'
      },
      {
        lat: '23-51-22-N',
        lon: '83-25-49-W',
        wt: '0'
      },
      {
        lat: '23-52-27-N',
        lon: '83-33-01-W',
        wt: '0'
      },
      {
        lat: '23-54-04-N',
        lon: '83-41-35-W',
        wt: '0'
      },
      {
        lat: '23-55-47-N',
        lon: '83-48-11-W',
        wt: '0'
      },
      {
        lat: '23-58-38-N',
        lon: '83-59-59-W',
        wt: '0'
      },
      {
        lat: '24-09-37-N',
        lon: '84-29-27-W',
        wt: '0'
      },
      {
        lat: '24-13-20-N',
        lon: '84-38-39-W',
        wt: '0'
      },
      {
        lat: '24-16-41-N',
        lon: '84-46-07-W',
        wt: '0'
      },
      {
        lat: '24-23-30-N',
        lon: '84-59-59-W',
        wt: '0'
      },
      {
        lat: '24-26-37-N',
        lon: '85-06-19-W',
        wt: '0'
      },
      {
        lat: '24-38-57-N',
        lon: '85-31-54-W',
        wt: '0'
      },
      {
        lat: '24-44-17-N',
        lon: '85-43-11-W',
        wt: '0'
      },
      {
        lat: '24-53-57-N',
        lon: '85-59-59-W',
        wt: '0'
      },
      {
        lat: '25-10-44-N',
        lon: '86-30-07-W',
        wt: '0'
      },
      {
        lat: '25-43-15-N',
        lon: '86-21-14-W',
        wt: '0'
      },
      {
        lat: '26-13-13-N',
        lon: '86-06-45-W',
        wt: '0'
      },
      {
        lat: '26-27-22-N',
        lon: '86-13-15-W',
        wt: '0'
      },
      {
        lat: '26-33-46-N',
        lon: '86-37-07-W',
        wt: '0'
      },
      {
        lat: '26-01-24-N',
        lon: '87-29-35-W',
        wt: '0'
      },
      {
        lat: '25-42-25-N',
        lon: '88-33-00-W',
        wt: '0'
      },
      {
        lat: '25-46-54-N',
        lon: '90-29-41-W',
        wt: '0'
      },
      {
        lat: '25-44-39-N',
        lon: '90-47-05-W',
        wt: '0'
      },
      {
        lat: '25-51-43-N',
        lon: '91-52-50-W',
        wt: '0'
      },
      {
        lat: '26-17-44-N',
        lon: '93-03-59-W',
        wt: '0'
      },
      {
        lat: '25-59-55-N',
        lon: '93-33-52-W',
        wt: '0'
      },
      {
        lat: '26-00-32-N',
        lon: '95-39-27-W',
        wt: '0'
      },
      {
        lat: '26-00-33-N',
        lon: '96-48-30-W',
        wt: '0'
      },
      {
        lat: '25-58-32-N',
        lon: '96-55-28-W',
        wt: '0'
      },
      {
        lat: '25-58-15-N',
        lon: '96-58-41-W',
        wt: '0'
      },
      {
        lat: '25-57-58-N',
        lon: '97-01-54-W',
        wt: '0'
      },
      {
        lat: '25-57-41-N',
        lon: '97-05-08-W',
        wt: '0'
      },
      {
        lat: '25-57-24-N',
        lon: '97-08-21-W',
        wt: '0'
      },
      {
        lat: '25-57-24-N',
        lon: '97-08-47-W',
        wt: '0'
      }
    ]
  },
  {
    name: 'Hawaiian Islands',
    data: [
      {
        lat: '22-32-54-N',
        lon: '153-00-33-W',
        wt: '0'
      },
      {
        lat: '23-06-05-N',
        lon: '153-28-36-W',
        wt: '0'
      },
      {
        lat: '23-32-11-N',
        lon: '154-02-12-W',
        wt: '0'
      },
      {
        lat: '23-51-47-N',
        lon: '154-36-48-W',
        wt: '0'
      },
      {
        lat: '24-21-49-N',
        lon: '155-51-13-W',
        wt: '0'
      },
      {
        lat: '24-41-47-N',
        lon: '156-27-27-W',
        wt: '0'
      },
      {
        lat: '24-57-33-N',
        lon: '157-22-17-W',
        wt: '0'
      },
      {
        lat: '25-13-41-N',
        lon: '157-54-13-W',
        wt: '0'
      },
      {
        lat: '25-25-31-N',
        lon: '158-30-36-W',
        wt: '0'
      },
      {
        lat: '25-31-19-N',
        lon: '159-09-47-W',
        wt: '0'
      },
      {
        lat: '25-30-31-N',
        lon: '159-54-21-W',
        wt: '0'
      },
      {
        lat: '25-21-53-N',
        lon: '160-39-53-W',
        wt: '0'
      },
      {
        lat: '25-00-06-N',
        lon: '161-38-33-W',
        wt: '0'
      },
      {
        lat: '24-40-49-N',
        lon: '162-13-13-W',
        wt: '0'
      },
      {
        lat: '24-15-53-N',
        lon: '162-43-08-W',
        wt: '0'
      },
      {
        lat: '23-40-50-N',
        lon: '163-13-00-W',
        wt: '0'
      },
      {
        lat: '23-03-20-N',
        lon: '163-32-58-W',
        wt: '0'
      },
      {
        lat: '22-20-09-N',
        lon: '163-44-41-W',
        wt: '0'
      },
      {
        lat: '21-36-45-N',
        lon: '163-46-03-W',
        wt: '0'
      },
      {
        lat: '20-55-26-N',
        lon: '163-37-44-W',
        wt: '0'
      },
      {
        lat: '20-13-34-N',
        lon: '163-19-13-W',
        wt: '0'
      },
      {
        lat: '19-39-03-N',
        lon: '162-53-48-W',
        wt: '0'
      },
      {
        lat: '19-09-43-N',
        lon: '162-20-35-W',
        wt: '0'
      },
      {
        lat: '18-39-16-N',
        lon: '161-19-14-W',
        wt: '0'
      },
      {
        lat: '18-30-31-N',
        lon: '160-38-30-W',
        wt: '0'
      },
      {
        lat: '18-29-31-N',
        lon: '159-56-17-W',
        wt: '0'
      },
      {
        lat: '18-10-41-N',
        lon: '159-14-08-W',
        wt: '0'
      },
      {
        lat: '17-31-17-N',
        lon: '158-56-55-W',
        wt: '0'
      },
      {
        lat: '16-54-06-N',
        lon: '158-30-29-W',
        wt: '0'
      },
      {
        lat: '16-25-49-N',
        lon: '157-59-25-W',
        wt: '0'
      },
      {
        lat: '15-59-57-N',
        lon: '157-17-35-W',
        wt: '0'
      },
      {
        lat: '15-40-37-N',
        lon: '156-21-06-W',
        wt: '0'
      },
      {
        lat: '15-37-36-N',
        lon: '155-22-16-W',
        wt: '0'
      },
      {
        lat: '15-43-46-N',
        lon: '154-46-37-W',
        wt: '0'
      },
      {
        lat: '15-55-32-N',
        lon: '154-13-05-W',
        wt: '0'
      },
      {
        lat: '16-46-27-N',
        lon: '152-49-11-W',
        wt: '0'
      },
      {
        lat: '17-33-42-N',
        lon: '152-00-32-W',
        wt: '0'
      },
      {
        lat: '17-33-42-N',
        lon: '152-00-32-W',
        wt: '0'
      },
      {
        lat: '18-30-16-N',
        lon: '151-30-24-W',
        wt: '0'
      },
      {
        lat: '19-02-47-N',
        lon: '151-22-17-W',
        wt: '0'
      },
      {
        lat: '19-34-46-N',
        lon: '151-19-47-W',
        wt: '0'
      },
      {
        lat: '20-07-42-N',
        lon: '151-22-58-W',
        wt: '0'
      },
      {
        lat: '20-38-43-N',
        lon: '151-31-36-W',
        wt: '0'
      },
      {
        lat: '21-29-09-N',
        lon: '151-59-50-W',
        wt: '0'
      },
      {
        lat: '22-06-58-N',
        lon: '152-31-25-W',
        wt: '0'
      },
      {
        lat: '22-32-54-N',
        lon: '153-00-33-W',
        wt: '0'
      }
    ]
  },
  {
    name: 'Caribbean sea',
    data: [
      {
        lat: '17-18-37-N',
        lon: '67-32-14-W',
        wt: '0'
      },
      {
        lat: '19-11-14-N',
        lon: '67-26-45-W',
        wt: '0'
      },
      {
        lat: '19-30-28-N',
        lon: '65-16-48-W',
        wt: '0'
      },
      {
        lat: '19-12-25-N',
        lon: '65-06-08-W',
        wt: '0'
      },
      {
        lat: '18-45-13-N',
        lon: '65-00-22-W',
        wt: '0'
      },
      {
        lat: '18-41-14-N',
        lon: '64-59-33-W',
        wt: '0'
      },
      {
        lat: '18-29-22-N',
        lon: '64-53-51-W',
        wt: '0'
      },
      {
        lat: '18-27-35-N',
        lon: '64-53-22-W',
        wt: '0'
      },
      {
        lat: '18-25-21-N',
        lon: '64-52-39-W',
        wt: '0'
      },
      {
        lat: '18-24-30-N',
        lon: '64-52-19-W',
        wt: '0'
      },
      {
        lat: '18-23-51-N',
        lon: '64-51-50-W',
        wt: '0'
      },
      {
        lat: '18-23-42-N',
        lon: '64-51-23-W',
        wt: '0'
      },
      {
        lat: '18-23-36-N',
        lon: '64-50-17-W',
        wt: '0'
      },
      {
        lat: '18-23-48-N',
        lon: '64-49-41-W',
        wt: '0'
      },
      {
        lat: '18-24-11-N',
        lon: '64-49-00-W',
        wt: '0'
      },
      {
        lat: '18-24-28-N',
        lon: '64-47-57-W',
        wt: '0'
      },
      {
        lat: '18-24-18-N',
        lon: '64-47-01-W',
        wt: '0'
      },
      {
        lat: '18-23-13-N',
        lon: '64-46-37-W',
        wt: '0'
      },
      {
        lat: '18-22-37-N',
        lon: '64-45-20-W',
        wt: '0'
      },
      {
        lat: '18-22-39-N',
        lon: '64-44-42-W',
        wt: '0'
      },
      {
        lat: '18-22-42-N',
        lon: '64-44-36-W',
        wt: '0'
      },
      {
        lat: '18-22-37-N',
        lon: '64-44-24-W',
        wt: '0'
      },
      {
        lat: '18-22-39-N',
        lon: '64-43-42-W',
        wt: '0'
      },
      {
        lat: '18-22-30-N',
        lon: '64-43-36-W',
        wt: '0'
      },
      {
        lat: '18-22-25-N',
        lon: '64-42-58-W',
        wt: '0'
      },
      {
        lat: '18-22-26-N',
        lon: '64-42-28-W',
        wt: '0'
      },
      {
        lat: '18-22-15-N',
        lon: '64-42-03-W',
        wt: '0'
      },
      {
        lat: '18-22-22-N',
        lon: '64-40-60-W',
        wt: '0'
      },
      {
        lat: '18-21-57-N',
        lon: '64-40-15-W',
        wt: '0'
      },
      {
        lat: '18-21-51-N',
        lon: '64-38-23-W',
        wt: '0'
      },
      {
        lat: '18-21-22-N',
        lon: '64-38-16-W',
        wt: '0'
      },
      {
        lat: '18-20-39-N',
        lon: '64-38-33-W',
        wt: '0'
      },
      {
        lat: '18-19-15-N',
        lon: '64-38-14-W',
        wt: '0'
      },
      {
        lat: '18-19-07-N',
        lon: '64-38-16-W',
        wt: '0'
      },
      {
        lat: '18-17-23-N',
        lon: '64-39-38-W',
        wt: '0'
      },
      {
        lat: '18-16-43-N',
        lon: '64-39-41-W',
        wt: '0'
      },
      {
        lat: '18-11-33-N',
        lon: '64-38-58-W',
        wt: '0'
      },
      {
        lat: '18-03-02-N',
        lon: '64-38-03-W',
        wt: '0'
      },
      {
        lat: '18-02-56-N',
        lon: '64-29-35-W',
        wt: '0'
      },
      {
        lat: '18-02-51-N',
        lon: '64-27-02-W',
        wt: '0'
      },
      {
        lat: '18-02-30-N',
        lon: '64-21-08-W',
        wt: '0'
      },
      {
        lat: '18-02-31-N',
        lon: '64-20-08-W',
        wt: '0'
      },
      {
        lat: '18-02-03-N',
        lon: '64-15-57-W',
        wt: '0'
      },
      {
        lat: '18-00-12-N',
        lon: '64-02-29-W',
        wt: '0'
      },
      {
        lat: '17-59-58-N',
        lon: '63-57-01-W',
        wt: '0'
      },
      {
        lat: '17-57-51-N',
        lon: '63-53-54-W',
        wt: '0'
      },
      {
        lat: '17-56-38-N',
        lon: '63-53-21-W',
        wt: '0'
      },
      {
        lat: '17-39-40-N',
        lon: '63-54-53-W',
        wt: '0'
      },
      {
        lat: '17-37-08-N',
        lon: '63-55-10-W',
        wt: '0'
      },
      {
        lat: '17-30-21-N',
        lon: '63-55-56-W',
        wt: '0'
      },
      {
        lat: '17-11-36-N',
        lon: '63-57-57-W',
        wt: '0'
      },
      {
        lat: '17-04-60-N',
        lon: '63-58-41-W',
        wt: '0'
      },
      {
        lat: '16-59-49-N',
        lon: '63-59-18-W',
        wt: '0'
      },
      {
        lat: '17-18-49-N',
        lon: '67-32-14-W',
        wt: '0'
      }
    ]
  },
  {
    name: 'Europe1',
    data: [
      {
        lat: '58-33-57-N',
        lon: '4-00-00-W',
        wt: '11'
      },
      {
        lat: '62-00-00-N',
        lon: '4-00-00-W',
        wt: '11'
      },
      {
        lat: '62-00-00-N',
        lon: '5-19-54-E',
        wt: '11'
      }
    ]
  },
  {
    name: 'Europe2',
    data: [
      {
        lat: '50-8-35-N',
        lon: '5-00-00-W',
        wt: '11'
      },
      {
        lat: '48-30-00-N',
        lon: '5-00-00-W',
        wt: '11'
      },
      {
        lat: '48-30-00-N',
        lon: '4-46-38-W',
        wt: '11'
      }
    ]
  },
  {
    name: 'China Coast',
    data: [
      {
        lat: '39-49-41-N',
        lon: '124-10-06-E',
        wt: '11'
      },
      {
        lat: '37-22-11.64-N',
        lon: '122-57-14.40-E',
        wt: '11'
      },
      {
        lat: '37-21-29.16-N',
        lon: '122-57-00-E',
        wt: '11'
      },
      {
        lat: '36-53-51.36-N',
        lon: '122-48-18-E',
        wt: '11'
      },
      {
        lat: '36-48-25.20-N',
        lon: '122-45-14.40-E',
        wt: '11'
      },
      {
        lat: '36-44-41.28-N',
        lon: '122-40-58.80-E',
        wt: '11'
      },
      {
        lat: '36-35-08.88-N',
        lon: '122-24-36-E',
        wt: '11'
      },
      {
        lat: '35-44-44.16-N',
        lon: '121-03-03.6-E',
        wt: '11'
      },
      {
        lat: '34-59-27.60-N',
        lon: '120-12-57.60-E',
        wt: '11'
      },
      {
        lat: '33-28-46.20-N',
        lon: '121-32-24-E',
        wt: '11'
      },
      {
        lat: '33-06-19.08-N',
        lon: '121-51-14.40-E',
        wt: '11'
      },
      {
        lat: '31-32-08.52-N',
        lon: '122-26-42-E',
        wt: '11'
      },
      {
        lat: '30-49-15.96-N',
        lon: '123-23-31.20-E',
        wt: '11'
      },
      {
        lat: '30-45-51.84-N',
        lon: '123-24-36-E',
        wt: '11'
      },
      {
        lat: '30-05-43.44-N',
        lon: '123-09-28.80-E',
        wt: '11'
      },
      {
        lat: '28-47-31.56-N',
        lon: '122-28-26.40-E',
        wt: '11'
      },
      {
        lat: '28-18-58.32-N',
        lon: '122-07-30-E',
        wt: '11'
      },
      {
        lat: '28-17-01.68-N',
        lon: '122-06-03.6-E',
        wt: '11'
      },
      {
        lat: '27-21-30.96-N',
        lon: '121-19-12-E',
        wt: '11'
      },
      {
        lat: '26-17-32.64-N',
        lon: '120-42-28.80-E',
        wt: '11'
      },
      {
        lat: '26-04-01.92-N',
        lon: '120-36-10.80-E',
        wt: '11'
      },
      {
        lat: '25-18-37.08-N',
        lon: '120-06-57.60-E',
        wt: '11'
      },
      {
        lat: '24-49-31.80-N',
        lon: '119-37-26.40-E',
        wt: '11'
      },
      {
        lat: '24-00-54-N',
        lon: '118-23-16.80-E',
        wt: '11'
      },
      {
        lat: '23-23-16.44-N',
        lon: '117-50-31.20-E',
        wt: '11'
      },
      {
        lat: '23-03-05.40-N',
        lon: '117-22-26.40-E',
        wt: '11'
      },
      {
        lat: '23-01-32.88-N',
        lon: '117-19-51.60-E',
        wt: '11'
      },
      {
        lat: '22-45-05.04-N',
        lon: '116-34-55.20-E',
        wt: '11'
      },
      {
        lat: '22-08-03.12-N',
        lon: '115-13-01.20-E',
        wt: '11'
      },
      {
        lat: '21-37-02.64-N',
        lon: '114-02-09.6-E',
        wt: '11'
      },
      {
        lat: '21-22-25.68-N',
        lon: '112-50-52.80-E',
        wt: '11'
      },
      {
        lat: '21-17-12.48-N',
        lon: '112-29-20.40-E',
        wt: '11'
      },
      {
        lat: '19-51-57.96-N',
        lon: '111-27-00-E',
        wt: '11'
      },
      {
        lat: '19-46-54.84-N',
        lon: '111-23-42-E',
        wt: '11'
      },
      {
        lat: '18-31-10.56-N',
        lon: '110-38-56.40-E',
        wt: '11'
      },
      {
        lat: '18-30-24.12-N',
        lon: '110-37-40.80-E',
        wt: '11'
      },
      {
        lat: '18-16-00.84-N',
        lon: '110-15-07.20-E',
        wt: '11'
      },
      {
        lat: '18-12-45.36-N',
        lon: '110-09-25.20-E',
        wt: '11'
      },
      {
        lat: '17-59-03.12-N',
        lon: '109-45-32.40-E',
        wt: '11'
      },
      {
        lat: '17-59-03.48-N',
        lon: '109-43-04.80-E',
        wt: '11'
      },
      {
        lat: '17-57-18.36-N',
        lon: '109-34-26.40-E',
        wt: '11'
      },
      {
        lat: '18-03-10.80-N',
        lon: '109-03-39.60-E',
        wt: '11'
      },
      {
        lat: '18-08-58.56-N',
        lon: '108-50-42-E',
        wt: '11'
      },
      {
        lat: '18-21-07.92-N',
        lon: '108-33-07.20-E',
        wt: '11'
      },
      {
        lat: '18-22-30-N',
        lon: '108-31-40.80-E',
        wt: '11'
      },
      {
        lat: '18-23-10.32-N',
        lon: '108-31-08.40-E',
        wt: '11'
      },
      {
        lat: '18-25-34.68-N',
        lon: '108-28-44.40-E',
        wt: '11'
      },
      {
        lat: '18-49-13.44-N',
        lon: '108-24-46.80-E',
        wt: '11'
      },
      {
        lat: '19-12-47.16-N',
        lon: '108-23-20.40-E',
        wt: '11'
      },
      {
        lat: '20-24-05-N',
        lon: '108-22-45-E',
        wt: '11'
      },
      {
        lat: '21-12-35-N',
        lon: '108-12-31-E',
        wt: '11'
      },
      {
        lat: '21-16-32-N',
        lon: '108-08-05-E',
        wt: '11'
      },
      {
        lat: '21-27-08.20-N',
        lon: '108-05-43.70-E',
        wt: '11'
      },
      {
        lat: '21-27-23.10-N',
        lon: '108-05-38.80-E',
        wt: '11'
      },
      {
        lat: '21-27-28.20-N',
        lon: '108-05-39.90-E',
        wt: '11'
      },
      {
        lat: '21-27-39.50-N',
        lon: '108-05-51.5-E',
        wt: '11'
      },
      {
        lat: '21-27-50.10-N',
        lon: '108-05-57.7-E',
        wt: '11'
      },
      {
        lat: '21-28-01.70-N',
        lon: '108-06-01.60-E',
        wt: '11'
      },
      {
        lat: '21-28-12.50-N',
        lon: '108-06-04.30-E',
        wt: '11'
      },
      {
        lat: '21-32-55-N',
        lon: '108-01-52-E',
        wt: '11'
      }
    ]
  }
]

const ecaAreaArrs = [
  {
    name: 'North America West',
    data: [
      {
        lat: '32-32-10-N',
        lon: '117-06-11-W',
        wt: '0'
      },
      {
        lat: '32-32-04-N',
        lon: '117-07-29-W',
        wt: '0'
      },
      {
        lat: '32-31-39-N',
        lon: '117-14-20-W',
        wt: '0'
      },
      {
        lat: '32-33-13-N',
        lon: '117-15-50-W',
        wt: '0'
      },
      {
        lat: '32-34-21-N',
        lon: '117-22-01-W',
        wt: '0'
      },
      {
        lat: '32-35-23-N',
        lon: '117-27-53-W',
        wt: '0'
      },
      {
        lat: '32-37-38-N',
        lon: '117-49-34-W',
        wt: '0'
      },
      {
        lat: '31-07-59-N',
        lon: '118-36-21-W',
        wt: '0'
      },
      {
        lat: '30-33-25-N',
        lon: '121-47-29-W',
        wt: '0'
      },
      {
        lat: '31-46-11-N',
        lon: '123-17-22-W',
        wt: '0'
      },
      {
        lat: '32-21-58-N',
        lon: '123-50-44-W',
        wt: '0'
      },
      {
        lat: '32-56-39-N',
        lon: '124-11-47-W',
        wt: '0'
      },
      {
        lat: '33-40-12-N',
        lon: '124-27-15-W',
        wt: '0'
      },
      {
        lat: '34-31-28-N',
        lon: '125-16-52-W',
        wt: '0'
      },
      {
        lat: '35-14-38-N',
        lon: '125-43-23-W',
        wt: '0'
      },
      {
        lat: '35-43-60-N',
        lon: '126-18-53-W',
        wt: '0'
      },
      {
        lat: '36-16-25-N',
        lon: '126-45-30-W',
        wt: '0'
      },
      {
        lat: '37-01-35-N',
        lon: '127-07-18-W',
        wt: '0'
      },
      {
        lat: '37-45-39-N',
        lon: '127-38-02-W',
        wt: '0'
      },
      {
        lat: '38-25-08-N',
        lon: '127-52-60-W',
        wt: '0'
      },
      {
        lat: '39-25-05-N',
        lon: '128-31-23-W',
        wt: '0'
      },
      {
        lat: '40-18-47-N',
        lon: '128-45-46-W',
        wt: '0'
      },
      {
        lat: '41-13-39-N',
        lon: '128-40-22-W',
        wt: '0'
      },
      {
        lat: '42-12-49-N',
        lon: '129-00-38-W',
        wt: '0'
      },
      {
        lat: '42-47-34-N',
        lon: '129-05-42-W',
        wt: '0'
      },
      {
        lat: '43-26-22-N',
        lon: '129-01-26-W',
        wt: '0'
      },
      {
        lat: '44-24-43-N',
        lon: '128-41-23-W',
        wt: '0'
      },
      {
        lat: '45-30-43-N',
        lon: '128-40-02-W',
        wt: '0'
      },
      {
        lat: '46-11-01-N',
        lon: '128-49-01-W',
        wt: '0'
      },
      {
        lat: '46-33-55-N',
        lon: '129-04-29-W',
        wt: '0'
      },
      {
        lat: '47-39-55-N',
        lon: '131-15-41-W',
        wt: '0'
      },
      {
        lat: '48-32-32-N',
        lon: '132-41-00-W',
        wt: '0'
      },
      {
        lat: '48-57-47-N',
        lon: '133-14-47-W',
        wt: '0'
      },
      {
        lat: '49-22-39-N',
        lon: '134-15-51-W',
        wt: '0'
      },
      {
        lat: '50-01-52-N',
        lon: '135-19-01-W',
        wt: '0'
      },
      {
        lat: '51-03-18-N',
        lon: '136-45-45-W',
        wt: '0'
      },
      {
        lat: '51-54-04-N',
        lon: '137-41-54-W',
        wt: '0'
      },
      {
        lat: '52-45-12-N',
        lon: '138-20-14-W',
        wt: '0'
      },
      {
        lat: '53-29-20-N',
        lon: '138-40-36-W',
        wt: '0'
      },
      {
        lat: '53-40-39-N',
        lon: '138-48-53-W',
        wt: '0'
      },
      {
        lat: '54-13-45-N',
        lon: '139-32-38-W',
        wt: '0'
      },
      {
        lat: '54-39-25-N',
        lon: '139-56-19-W',
        wt: '0'
      },
      {
        lat: '55-20-18-N',
        lon: '140-55-45-W',
        wt: '0'
      },
      {
        lat: '56-07-12-N',
        lon: '141-36-18-W',
        wt: '0'
      },
      {
        lat: '56-28-32-N',
        lon: '142-17-19-W',
        wt: '0'
      },
      {
        lat: '56-37-19-N',
        lon: '142-48-57-W',
        wt: '0'
      },
      {
        lat: '58-51-04-N',
        lon: '153-15-03-W',
        wt: '0'
      },
      {
        lat: '58-56-43-N',
        lon: '154-55-16-W',
        wt: '0'
      },
      {
        lat: '60-11-00-N',
        lon: '153-01-33-W',
        wt: '0'
      },
      {
        lat: '64-58-06-N',
        lon: '142-42-35-W',
        wt: '0'
      },
      {
        lat: '37-02-05-N',
        lon: '109-13-24-W',
        wt: '0'
      }
    ]
  },
  {
    name: 'North America East',
    data: [
      {
        lat: '60-00-00-N',
        lon: '64-09-36-W',
        wt: '11'
      },
      {
        lat: '60-00-00-N',
        lon: '56-43-00-W',
        wt: '11'
      },
      {
        lat: '58-54-01-N',
        lon: '55-38-05-W',
        wt: '0'
      },
      {
        lat: '57-50-52-N',
        lon: '55-03-47-W',
        wt: '0'
      },
      {
        lat: '57-35-13-N',
        lon: '54-00-59-W',
        wt: '0'
      },
      {
        lat: '57-14-20-N',
        lon: '53-07-58-W',
        wt: '0'
      },
      {
        lat: '56-48-09-N',
        lon: '52-23-29-W',
        wt: '0'
      },
      {
        lat: '56-18-13-N',
        lon: '51-49-42-W',
        wt: '0'
      },
      {
        lat: '54-23-21-N',
        lon: '50-17-44-W',
        wt: '0'
      },
      {
        lat: '53-44-54-N',
        lon: '50-07-17-W',
        wt: '0'
      },
      {
        lat: '53-04-59-N',
        lon: '50-10-05-W',
        wt: '0'
      },
      {
        lat: '52-20-06-N',
        lon: '49-57-09-W',
        wt: '0'
      },
      {
        lat: '51-34-20-N',
        lon: '48-52-45-W',
        wt: '0'
      },
      {
        lat: '50-40-15-N',
        lon: '48-16-04-W',
        wt: '0'
      },
      {
        lat: '50-02-28-N',
        lon: '48-07-03-W',
        wt: '0'
      },
      {
        lat: '49-24-03-N',
        lon: '48-09-35-W',
        wt: '0'
      },
      {
        lat: '48-39-22-N',
        lon: '47-55-17-W',
        wt: '0'
      },
      {
        lat: '47-24-25-N',
        lon: '47-46-56-W',
        wt: '0'
      },
      {
        lat: '46-35-12-N',
        lon: '48-00-54-W',
        wt: '0'
      },
      {
        lat: '45-19-45-N',
        lon: '48-43-28-W',
        wt: '0'
      },
      {
        lat: '44-43-38-N',
        lon: '49-16-50-W',
        wt: '0'
      },
      {
        lat: '44-16-38-N',
        lon: '49-51-23-W',
        wt: '0'
      },
      {
        lat: '43-53-15-N',
        lon: '50-34-01-W',
        wt: '0'
      },
      {
        lat: '43-36-06-N',
        lon: '51-20-41-W',
        wt: '0'
      },
      {
        lat: '43-23-59-N',
        lon: '52-17-22-W',
        wt: '0'
      },
      {
        lat: '43-19-50-N',
        lon: '53-20-13-W',
        wt: '0'
      },
      {
        lat: '43-21-14-N',
        lon: '54-09-20-W',
        wt: '0'
      },
      {
        lat: '43-29-41-N',
        lon: '55-07-41-W',
        wt: '0'
      },
      {
        lat: '42-40-12-N',
        lon: '55-31-44-W',
        wt: '0'
      },
      {
        lat: '41-58-19-N',
        lon: '56-09-34-W',
        wt: '0'
      },
      {
        lat: '41-20-21-N',
        lon: '57-05-13-W',
        wt: '0'
      },
      {
        lat: '40-55-34-N',
        lon: '58-02-55-W',
        wt: '0'
      },
      {
        lat: '40-41-38-N',
        lon: '59-05-18-W',
        wt: '0'
      },
      {
        lat: '40-38-33-N',
        lon: '60-12-20-W',
        wt: '0'
      },
      {
        lat: '40-45-46-N',
        lon: '61-14-03-W',
        wt: '0'
      },
      {
        lat: '41-04-52-N',
        lon: '62-17-49-W',
        wt: '0'
      },
      {
        lat: '40-36-55-N',
        lon: '63-10-49-W',
        wt: '0'
      },
      {
        lat: '40-17-32-N',
        lon: '64-08-37-W',
        wt: '0'
      },
      {
        lat: '40-07-32-N',
        lon: '64-59-31-W',
        wt: '0'
      },
      {
        lat: '40-05-44-N',
        lon: '65-53-07-W',
        wt: '0'
      },
      {
        lat: '39-58-05-N',
        lon: '65-59-51-W',
        wt: '0'
      },
      {
        lat: '39-28-24-N',
        lon: '66-21-14-W',
        wt: '0'
      },
      {
        lat: '39-01-54-N',
        lon: '66-48-33-W',
        wt: '0'
      },
      {
        lat: '38-39-16-N',
        lon: '67-20-59-W',
        wt: '0'
      },
      {
        lat: '38-19-20-N',
        lon: '68-02-01-W',
        wt: '0'
      },
      {
        lat: '38-05-29-N',
        lon: '68-46-55-W',
        wt: '0'
      },
      {
        lat: '37-58-14-N',
        lon: '69-34-07-W',
        wt: '0'
      },
      {
        lat: '37-57-47-N',
        lon: '70-24-09-W',
        wt: '0'
      },
      {
        lat: '37-52-46-N',
        lon: '70-37-50-W',
        wt: '0'
      },
      {
        lat: '37-18-37-N',
        lon: '71-08-33-W',
        wt: '0'
      },
      {
        lat: '36-32-25-N',
        lon: '71-33-59-W',
        wt: '0'
      },
      {
        lat: '35-34-58-N',
        lon: '71-26-02-W',
        wt: '0'
      },
      {
        lat: '34-33-10-N',
        lon: '71-37-04-W',
        wt: '0'
      },
      {
        lat: '33-54-49-N',
        lon: '71-52-35-W',
        wt: '0'
      },
      {
        lat: '33-19-23-N',
        lon: '72-17-12-W',
        wt: '0'
      },
      {
        lat: '32-45-31-N',
        lon: '72-54-05-W',
        wt: '0'
      },
      {
        lat: '31-55-13-N',
        lon: '74-12-02-W',
        wt: '0'
      },
      {
        lat: '31-27-14-N',
        lon: '75-15-20-W',
        wt: '0'
      },
      {
        lat: '31-03-16-N',
        lon: '75-51-18-W',
        wt: '0'
      },
      {
        lat: '30-45-42-N',
        lon: '76-31-38-W',
        wt: '0'
      },
      {
        lat: '30-12-48-N',
        lon: '77-18-29-W',
        wt: '0'
      },
      {
        lat: '29-25-17-N',
        lon: '76-56-42-W',
        wt: '0'
      },
      {
        lat: '28-36-59-N',
        lon: '76-47-60-W',
        wt: '0'
      },
      {
        lat: '28-17-13-N',
        lon: '76-40-10-W',
        wt: '0'
      },
      {
        lat: '28-17-12-N',
        lon: '79-11-23-W',
        wt: '0'
      },
      {
        lat: '27-52-56-N',
        lon: '79-28-35-W',
        wt: '0'
      },
      {
        lat: '27-26-01-N',
        lon: '79-31-38-W',
        wt: '0'
      },
      {
        lat: '27-16-13-N',
        lon: '79-34-18-W',
        wt: '0'
      },
      {
        lat: '27-11-54-N',
        lon: '79-34-56-W',
        wt: '0'
      },
      {
        lat: '27-05-59-N',
        lon: '79-35-19-W',
        wt: '0'
      },
      {
        lat: '27-00-28-N',
        lon: '79-35-17-W',
        wt: '0'
      },
      {
        lat: '26-55-16-N',
        lon: '79-34-39-W',
        wt: '0'
      },
      {
        lat: '26-53-58-N',
        lon: '79-34-27-W',
        wt: '0'
      },
      {
        lat: '26-45-46-N',
        lon: '79-32-41-W',
        wt: '0'
      },
      {
        lat: '26-44-30-N',
        lon: '79-32-23-W',
        wt: '0'
      },
      {
        lat: '26-43-40-N',
        lon: '79-32-20-W',
        wt: '0'
      },
      {
        lat: '26-41-12-N',
        lon: '79-32-01-W',
        wt: '0'
      },
      {
        lat: '26-38-13-N',
        lon: '79-31-32-W',
        wt: '0'
      },
      {
        lat: '26-36-30-N',
        lon: '79-31-06-W',
        wt: '0'
      },
      {
        lat: '26-35-21-N',
        lon: '79-30-50-W',
        wt: '0'
      },
      {
        lat: '26-34-51-N',
        lon: '79-30-46-W',
        wt: '0'
      },
      {
        lat: '26-34-11-N',
        lon: '79-30-38-W',
        wt: '0'
      },
      {
        lat: '26-31-12-N',
        lon: '79-30-15-W',
        wt: '0'
      },
      {
        lat: '26-29-05-N',
        lon: '79-29-53-W',
        wt: '0'
      },
      {
        lat: '26-25-31-N',
        lon: '79-29-58-W',
        wt: '0'
      },
      {
        lat: '26-23-29-N',
        lon: '79-29-55-W',
        wt: '0'
      },
      {
        lat: '26-23-21-N',
        lon: '79-29-54-W',
        wt: '0'
      },
      {
        lat: '26-18-57-N',
        lon: '79-31-55-W',
        wt: '0'
      },
      {
        lat: '26-15-26-N',
        lon: '79-33-17-W',
        wt: '0'
      },
      {
        lat: '26-15-13-N',
        lon: '79-33-23-W',
        wt: '0'
      },
      {
        lat: '26-08-09-N',
        lon: '79-35-53-W',
        wt: '0'
      },
      {
        lat: '26-07-47-N',
        lon: '79-36-09-W',
        wt: '0'
      },
      {
        lat: '26-06-59-N',
        lon: '79-36-35-W',
        wt: '0'
      },
      {
        lat: '26-02-52-N',
        lon: '79-38-22-W',
        wt: '0'
      },
      {
        lat: '25-59-30-N',
        lon: '79-40-03-W',
        wt: '0'
      },
      {
        lat: '25-59-16-N',
        lon: '79-41-08-W',
        wt: '0'
      },
      {
        lat: '25-57-48-N',
        lon: '79-40-38-W',
        wt: '0'
      },
      {
        lat: '25-56-18-N',
        lon: '79-41-06-W',
        wt: '0'
      },
      {
        lat: '25-54-04-N',
        lon: '79-41-38-W',
        wt: '0'
      },
      {
        lat: '25-53-24-N',
        lon: '79-41-46-W',
        wt: '0'
      },
      {
        lat: '25-51-54-N',
        lon: '79-41-59-W',
        wt: '0'
      },
      {
        lat: '25-49-33-N',
        lon: '79-42-16-W',
        wt: '0'
      },
      {
        lat: '25-48-24-N',
        lon: '79-42-23-W',
        wt: '0'
      },
      {
        lat: '25-48-20-N',
        lon: '79-42-24-W',
        wt: '0'
      },
      {
        lat: '25-46-26-N',
        lon: '79-42-44-W',
        wt: '0'
      },
      {
        lat: '25-46-16-N',
        lon: '79-42-45-W',
        wt: '0'
      },
      {
        lat: '25-43-40-N',
        lon: '79-42-59-W',
        wt: '0'
      },
      {
        lat: '25-42-31-N',
        lon: '79-42-48-W',
        wt: '0'
      },
      {
        lat: '25-40-37-N',
        lon: '79-42-27-W',
        wt: '0'
      },
      {
        lat: '25-37-24-N',
        lon: '79-42-27-W',
        wt: '0'
      },
      {
        lat: '25-37-08-N',
        lon: '79-42-27-W',
        wt: '0'
      },
      {
        lat: '25-31-03-N',
        lon: '79-42-12-W',
        wt: '0'
      },
      {
        lat: '25-27-59-N',
        lon: '79-42-11-W',
        wt: '0'
      },
      {
        lat: '25-24-04-N',
        lon: '79-42-12-W',
        wt: '0'
      },
      {
        lat: '25-22-21-N',
        lon: '79-42-20-W',
        wt: '0'
      },
      {
        lat: '25-21-29-N',
        lon: '79-42-08-W',
        wt: '0'
      },
      {
        lat: '25-16-52-N',
        lon: '79-41-24-W',
        wt: '0'
      },
      {
        lat: '25-15-57-N',
        lon: '79-41-31-W',
        wt: '0'
      },
      {
        lat: '25-10-39-N',
        lon: '79-41-31-W',
        wt: '0'
      },
      {
        lat: '25-09-51-N',
        lon: '79-41-36-W',
        wt: '0'
      },
      {
        lat: '25-09-03-N',
        lon: '79-41-45-W',
        wt: '0'
      },
      {
        lat: '25-03-55-N',
        lon: '79-42-29-W',
        wt: '0'
      },
      {
        lat: '25-02-60-N',
        lon: '79-42-56-W',
        wt: '0'
      },
      {
        lat: '25-00-30-N',
        lon: '79-44-05-W',
        wt: '0'
      },
      {
        lat: '24-59-03-N',
        lon: '79-44-48-W',
        wt: '0'
      },
      {
        lat: '24-55-28-N',
        lon: '79-45-57-W',
        wt: '0'
      },
      {
        lat: '24-44-18-N',
        lon: '79-49-24-W',
        wt: '0'
      },
      {
        lat: '24-43-04-N',
        lon: '79-49-38-W',
        wt: '0'
      },
      {
        lat: '24-42-36-N',
        lon: '79-50-50-W',
        wt: '0'
      },
      {
        lat: '24-41-47-N',
        lon: '79-52-57-W',
        wt: '0'
      },
      {
        lat: '24-38-32-N',
        lon: '79-59-58-W',
        wt: '0'
      },
      {
        lat: '24-36-27-N',
        lon: '80-03-51-W',
        wt: '0'
      },
      {
        lat: '24-33-18-N',
        lon: '80-12-43-W',
        wt: '0'
      },
      {
        lat: '24-33-05-N',
        lon: '80-13-21-W',
        wt: '0'
      },
      {
        lat: '24-32-13-N',
        lon: '80-15-16-W',
        wt: '0'
      },
      {
        lat: '24-31-27-N',
        lon: '80-17-47-W',
        wt: '0'
      },
      {
        lat: '24-30-14-N',
        lon: '80-19-21-W',
        wt: '0'
      },
      {
        lat: '24-30-06-N',
        lon: '80-19-44-W',
        wt: '0'
      },
      {
        lat: '24-29-38-N',
        lon: '80-21-05-W',
        wt: '0'
      },
      {
        lat: '24-28-18-N',
        lon: '80-24-35-W',
        wt: '0'
      },
      {
        lat: '24-28-06-N',
        lon: '80-25-10-W',
        wt: '0'
      },
      {
        lat: '24-27-23-N',
        lon: '80-27-20-W',
        wt: '0'
      },
      {
        lat: '24-26-30-N',
        lon: '80-29-30-W',
        wt: '0'
      },
      {
        lat: '24-25-07-N',
        lon: '80-32-22-W',
        wt: '0'
      },
      {
        lat: '24-23-30-N',
        lon: '80-36-09-W',
        wt: '0'
      },
      {
        lat: '24-22-33-N',
        lon: '80-38-56-W',
        wt: '0'
      },
      {
        lat: '24-22-07-N',
        lon: '80-39-51-W',
        wt: '0'
      },
      {
        lat: '24-19-31-N',
        lon: '80-45-21-W',
        wt: '0'
      },
      {
        lat: '24-19-16-N',
        lon: '80-45-47-W',
        wt: '0'
      },
      {
        lat: '24-18-38-N',
        lon: '80-46-49-W',
        wt: '0'
      },
      {
        lat: '24-18-35-N',
        lon: '80-46-54-W',
        wt: '0'
      },
      {
        lat: '24-09-51-N',
        lon: '80-59-47-W',
        wt: '0'
      },
      {
        lat: '24-09-48-N',
        lon: '80-59-51-W',
        wt: '0'
      },
      {
        lat: '24-08-58-N',
        lon: '81-01-07-W',
        wt: '0'
      },
      {
        lat: '24-08-30-N',
        lon: '81-01-51-W',
        wt: '0'
      },
      {
        lat: '24-08-26-N',
        lon: '81-01-57-W',
        wt: '0'
      },
      {
        lat: '24-07-28-N',
        lon: '81-03-06-W',
        wt: '0'
      },
      {
        lat: '24-02-20-N',
        lon: '81-09-05-W',
        wt: '0'
      },
      {
        lat: '23-59-60-N',
        lon: '81-11-16-W',
        wt: '0'
      },
      {
        lat: '23-55-32-N',
        lon: '81-12-55-W',
        wt: '0'
      },
      {
        lat: '23-53-52-N',
        lon: '81-19-43-W',
        wt: '0'
      },
      {
        lat: '23-50-52-N',
        lon: '81-29-59-W',
        wt: '0'
      },
      {
        lat: '23-50-02-N',
        lon: '81-39-59-W',
        wt: '0'
      },
      {
        lat: '23-49-05-N',
        lon: '81-49-59-W',
        wt: '0'
      },
      {
        lat: '23-49-05-N',
        lon: '82-00-11-W',
        wt: '0'
      },
      {
        lat: '23-49-42-N',
        lon: '82-09-59-W',
        wt: '0'
      },
      {
        lat: '23-51-14-N',
        lon: '82-24-59-W',
        wt: '0'
      },
      {
        lat: '23-51-14-N',
        lon: '82-39-59-W',
        wt: '0'
      },
      {
        lat: '23-49-42-N',
        lon: '82-48-53-W',
        wt: '0'
      },
      {
        lat: '23-49-32-N',
        lon: '82-51-11-W',
        wt: '0'
      },
      {
        lat: '23-49-24-N',
        lon: '82-59-59-W',
        wt: '0'
      },
      {
        lat: '23-49-52-N',
        lon: '83-14-59-W',
        wt: '0'
      },
      {
        lat: '23-51-22-N',
        lon: '83-25-49-W',
        wt: '0'
      },
      {
        lat: '23-52-27-N',
        lon: '83-33-01-W',
        wt: '0'
      },
      {
        lat: '23-54-04-N',
        lon: '83-41-35-W',
        wt: '0'
      },
      {
        lat: '23-55-47-N',
        lon: '83-48-11-W',
        wt: '0'
      },
      {
        lat: '23-58-38-N',
        lon: '83-59-59-W',
        wt: '0'
      },
      {
        lat: '24-09-37-N',
        lon: '84-29-27-W',
        wt: '0'
      },
      {
        lat: '24-13-20-N',
        lon: '84-38-39-W',
        wt: '0'
      },
      {
        lat: '24-16-41-N',
        lon: '84-46-07-W',
        wt: '0'
      },
      {
        lat: '24-23-30-N',
        lon: '84-59-59-W',
        wt: '0'
      },
      {
        lat: '24-26-37-N',
        lon: '85-06-19-W',
        wt: '0'
      },
      {
        lat: '24-38-57-N',
        lon: '85-31-54-W',
        wt: '0'
      },
      {
        lat: '24-44-17-N',
        lon: '85-43-11-W',
        wt: '0'
      },
      {
        lat: '24-53-57-N',
        lon: '85-59-59-W',
        wt: '0'
      },
      {
        lat: '25-10-44-N',
        lon: '86-30-07-W',
        wt: '0'
      },
      {
        lat: '25-43-15-N',
        lon: '86-21-14-W',
        wt: '0'
      },
      {
        lat: '26-13-13-N',
        lon: '86-06-45-W',
        wt: '0'
      },
      {
        lat: '26-27-22-N',
        lon: '86-13-15-W',
        wt: '0'
      },
      {
        lat: '26-33-46-N',
        lon: '86-37-07-W',
        wt: '0'
      },
      {
        lat: '26-01-24-N',
        lon: '87-29-35-W',
        wt: '0'
      },
      {
        lat: '25-42-25-N',
        lon: '88-33-00-W',
        wt: '0'
      },
      {
        lat: '25-46-54-N',
        lon: '90-29-41-W',
        wt: '0'
      },
      {
        lat: '25-44-39-N',
        lon: '90-47-05-W',
        wt: '0'
      },
      {
        lat: '25-51-43-N',
        lon: '91-52-50-W',
        wt: '0'
      },
      {
        lat: '26-17-44-N',
        lon: '93-03-59-W',
        wt: '0'
      },
      {
        lat: '25-59-55-N',
        lon: '93-33-52-W',
        wt: '0'
      },
      {
        lat: '26-00-32-N',
        lon: '95-39-27-W',
        wt: '0'
      },
      {
        lat: '26-00-33-N',
        lon: '96-48-30-W',
        wt: '0'
      },
      {
        lat: '25-58-32-N',
        lon: '96-55-28-W',
        wt: '0'
      },
      {
        lat: '25-58-15-N',
        lon: '96-58-41-W',
        wt: '0'
      },
      {
        lat: '25-57-58-N',
        lon: '97-01-54-W',
        wt: '0'
      },
      {
        lat: '25-57-41-N',
        lon: '97-05-08-W',
        wt: '0'
      },
      {
        lat: '25-57-24-N',
        lon: '97-08-21-W',
        wt: '0'
      },
      {
        lat: '25-57-24-N',
        lon: '97-08-47-W',
        wt: '0'
      },
      {
        lat: '27-08-49-N',
        lon: '98-55-54-W',
        wt: '0'
      },
      {
        lat: '48-48-50-N',
        lon: '94-03-14-W',
        wt: '0'
      },
      {
        lat: '52-24-32-N',
        lon: '88-28-22-W',
        wt: '0'
      },
      {
        lat: '48-37-11-N',
        lon: '77-16-48-W',
        wt: '0'
      }
    ]
  },
  {
    name: 'Hawaiian Islands',
    data: [
      {
        lat: '22-32-54-N',
        lon: '153-00-33-W',
        wt: '0'
      },
      {
        lat: '23-06-05-N',
        lon: '153-28-36-W',
        wt: '0'
      },
      {
        lat: '23-32-11-N',
        lon: '154-02-12-W',
        wt: '0'
      },
      {
        lat: '23-51-47-N',
        lon: '154-36-48-W',
        wt: '0'
      },
      {
        lat: '24-21-49-N',
        lon: '155-51-13-W',
        wt: '0'
      },
      {
        lat: '24-41-47-N',
        lon: '156-27-27-W',
        wt: '0'
      },
      {
        lat: '24-57-33-N',
        lon: '157-22-17-W',
        wt: '0'
      },
      {
        lat: '25-13-41-N',
        lon: '157-54-13-W',
        wt: '0'
      },
      {
        lat: '25-25-31-N',
        lon: '158-30-36-W',
        wt: '0'
      },
      {
        lat: '25-31-19-N',
        lon: '159-09-47-W',
        wt: '0'
      },
      {
        lat: '25-30-31-N',
        lon: '159-54-21-W',
        wt: '0'
      },
      {
        lat: '25-21-53-N',
        lon: '160-39-53-W',
        wt: '0'
      },
      {
        lat: '25-00-06-N',
        lon: '161-38-33-W',
        wt: '0'
      },
      {
        lat: '24-40-49-N',
        lon: '162-13-13-W',
        wt: '0'
      },
      {
        lat: '24-15-53-N',
        lon: '162-43-08-W',
        wt: '0'
      },
      {
        lat: '23-40-50-N',
        lon: '163-13-00-W',
        wt: '0'
      },
      {
        lat: '23-03-20-N',
        lon: '163-32-58-W',
        wt: '0'
      },
      {
        lat: '22-20-09-N',
        lon: '163-44-41-W',
        wt: '0'
      },
      {
        lat: '21-36-45-N',
        lon: '163-46-03-W',
        wt: '0'
      },
      {
        lat: '20-55-26-N',
        lon: '163-37-44-W',
        wt: '0'
      },
      {
        lat: '20-13-34-N',
        lon: '163-19-13-W',
        wt: '0'
      },
      {
        lat: '19-39-03-N',
        lon: '162-53-48-W',
        wt: '0'
      },
      {
        lat: '19-09-43-N',
        lon: '162-20-35-W',
        wt: '0'
      },
      {
        lat: '18-39-16-N',
        lon: '161-19-14-W',
        wt: '0'
      },
      {
        lat: '18-30-31-N',
        lon: '160-38-30-W',
        wt: '0'
      },
      {
        lat: '18-29-31-N',
        lon: '159-56-17-W',
        wt: '0'
      },
      {
        lat: '18-10-41-N',
        lon: '159-14-08-W',
        wt: '0'
      },
      {
        lat: '17-31-17-N',
        lon: '158-56-55-W',
        wt: '0'
      },
      {
        lat: '16-54-06-N',
        lon: '158-30-29-W',
        wt: '0'
      },
      {
        lat: '16-25-49-N',
        lon: '157-59-25-W',
        wt: '0'
      },
      {
        lat: '15-59-57-N',
        lon: '157-17-35-W',
        wt: '0'
      },
      {
        lat: '15-40-37-N',
        lon: '156-21-06-W',
        wt: '0'
      },
      {
        lat: '15-37-36-N',
        lon: '155-22-16-W',
        wt: '0'
      },
      {
        lat: '15-43-46-N',
        lon: '154-46-37-W',
        wt: '0'
      },
      {
        lat: '15-55-32-N',
        lon: '154-13-05-W',
        wt: '0'
      },
      {
        lat: '16-46-27-N',
        lon: '152-49-11-W',
        wt: '0'
      },
      {
        lat: '17-33-42-N',
        lon: '152-00-32-W',
        wt: '0'
      },
      {
        lat: '17-33-42-N',
        lon: '152-00-32-W',
        wt: '0'
      },
      {
        lat: '18-30-16-N',
        lon: '151-30-24-W',
        wt: '0'
      },
      {
        lat: '19-02-47-N',
        lon: '151-22-17-W',
        wt: '0'
      },
      {
        lat: '19-34-46-N',
        lon: '151-19-47-W',
        wt: '0'
      },
      {
        lat: '20-07-42-N',
        lon: '151-22-58-W',
        wt: '0'
      },
      {
        lat: '20-38-43-N',
        lon: '151-31-36-W',
        wt: '0'
      },
      {
        lat: '21-29-09-N',
        lon: '151-59-50-W',
        wt: '0'
      },
      {
        lat: '22-06-58-N',
        lon: '152-31-25-W',
        wt: '0'
      },
      {
        lat: '22-32-54-N',
        lon: '153-00-33-W',
        wt: '0'
      }
    ]
  },
  {
    name: 'Caribbean sea',
    data: [
      {
        lat: '17-18-37-N',
        lon: '67-32-14-W',
        wt: '0'
      },
      {
        lat: '19-11-14-N',
        lon: '67-26-45-W',
        wt: '0'
      },
      {
        lat: '19-30-28-N',
        lon: '65-16-48-W',
        wt: '0'
      },
      {
        lat: '19-12-25-N',
        lon: '65-06-08-W',
        wt: '0'
      },
      {
        lat: '18-45-13-N',
        lon: '65-00-22-W',
        wt: '0'
      },
      {
        lat: '18-41-14-N',
        lon: '64-59-33-W',
        wt: '0'
      },
      {
        lat: '18-29-22-N',
        lon: '64-53-51-W',
        wt: '0'
      },
      {
        lat: '18-27-35-N',
        lon: '64-53-22-W',
        wt: '0'
      },
      {
        lat: '18-25-21-N',
        lon: '64-52-39-W',
        wt: '0'
      },
      {
        lat: '18-24-30-N',
        lon: '64-52-19-W',
        wt: '0'
      },
      {
        lat: '18-23-51-N',
        lon: '64-51-50-W',
        wt: '0'
      },
      {
        lat: '18-23-42-N',
        lon: '64-51-23-W',
        wt: '0'
      },
      {
        lat: '18-23-36-N',
        lon: '64-50-17-W',
        wt: '0'
      },
      {
        lat: '18-23-48-N',
        lon: '64-49-41-W',
        wt: '0'
      },
      {
        lat: '18-24-11-N',
        lon: '64-49-00-W',
        wt: '0'
      },
      {
        lat: '18-24-28-N',
        lon: '64-47-57-W',
        wt: '0'
      },
      {
        lat: '18-24-18-N',
        lon: '64-47-01-W',
        wt: '0'
      },
      {
        lat: '18-23-13-N',
        lon: '64-46-37-W',
        wt: '0'
      },
      {
        lat: '18-22-37-N',
        lon: '64-45-20-W',
        wt: '0'
      },
      {
        lat: '18-22-39-N',
        lon: '64-44-42-W',
        wt: '0'
      },
      {
        lat: '18-22-42-N',
        lon: '64-44-36-W',
        wt: '0'
      },
      {
        lat: '18-22-37-N',
        lon: '64-44-24-W',
        wt: '0'
      },
      {
        lat: '18-22-39-N',
        lon: '64-43-42-W',
        wt: '0'
      },
      {
        lat: '18-22-30-N',
        lon: '64-43-36-W',
        wt: '0'
      },
      {
        lat: '18-22-25-N',
        lon: '64-42-58-W',
        wt: '0'
      },
      {
        lat: '18-22-26-N',
        lon: '64-42-28-W',
        wt: '0'
      },
      {
        lat: '18-22-15-N',
        lon: '64-42-03-W',
        wt: '0'
      },
      {
        lat: '18-22-22-N',
        lon: '64-40-60-W',
        wt: '0'
      },
      {
        lat: '18-21-57-N',
        lon: '64-40-15-W',
        wt: '0'
      },
      {
        lat: '18-21-51-N',
        lon: '64-38-23-W',
        wt: '0'
      },
      {
        lat: '18-21-22-N',
        lon: '64-38-16-W',
        wt: '0'
      },
      {
        lat: '18-20-39-N',
        lon: '64-38-33-W',
        wt: '0'
      },
      {
        lat: '18-19-15-N',
        lon: '64-38-14-W',
        wt: '0'
      },
      {
        lat: '18-19-07-N',
        lon: '64-38-16-W',
        wt: '0'
      },
      {
        lat: '18-17-23-N',
        lon: '64-39-38-W',
        wt: '0'
      },
      {
        lat: '18-16-43-N',
        lon: '64-39-41-W',
        wt: '0'
      },
      {
        lat: '18-11-33-N',
        lon: '64-38-58-W',
        wt: '0'
      },
      {
        lat: '18-03-02-N',
        lon: '64-38-03-W',
        wt: '0'
      },
      {
        lat: '18-02-56-N',
        lon: '64-29-35-W',
        wt: '0'
      },
      {
        lat: '18-02-51-N',
        lon: '64-27-02-W',
        wt: '0'
      },
      {
        lat: '18-02-30-N',
        lon: '64-21-08-W',
        wt: '0'
      },
      {
        lat: '18-02-31-N',
        lon: '64-20-08-W',
        wt: '0'
      },
      {
        lat: '18-02-03-N',
        lon: '64-15-57-W',
        wt: '0'
      },
      {
        lat: '18-00-12-N',
        lon: '64-02-29-W',
        wt: '0'
      },
      {
        lat: '17-59-58-N',
        lon: '63-57-01-W',
        wt: '0'
      },
      {
        lat: '17-57-51-N',
        lon: '63-53-54-W',
        wt: '0'
      },
      {
        lat: '17-56-38-N',
        lon: '63-53-21-W',
        wt: '0'
      },
      {
        lat: '17-39-40-N',
        lon: '63-54-53-W',
        wt: '0'
      },
      {
        lat: '17-37-08-N',
        lon: '63-55-10-W',
        wt: '0'
      },
      {
        lat: '17-30-21-N',
        lon: '63-55-56-W',
        wt: '0'
      },
      {
        lat: '17-11-36-N',
        lon: '63-57-57-W',
        wt: '0'
      },
      {
        lat: '17-04-60-N',
        lon: '63-58-41-W',
        wt: '0'
      },
      {
        lat: '16-59-49-N',
        lon: '63-59-18-W',
        wt: '0'
      },
      {
        lat: '17-18-49-N',
        lon: '67-32-14-W',
        wt: '0'
      }
    ]
  },
  {
    name: 'Europe',
    data: [
      {
        lat: '50-08-35-N',
        lon: '05-00-00-W',
        wt: '11'
      },
      {
        lat: '48-30-00-N',
        lon: '05-00-00-W',
        wt: '11'
      },
      {
        lat: '48-30-00-N',
        lon: '04-46-38-W',
        wt: '11'
      },
      {
        lat: '47-38-26-N',
        lon: '05-04-39-E',
        wt: '11'
      },
      {
        lat: '58-29-09-N',
        lon: '31-58-20-E',
        wt: '11'
      },
      {
        lat: '59-56-31-N',
        lon: '30-20-06-E',
        wt: '11'
      },
      {
        lat: '68-03-04-N',
        lon: '24-34-02-E',
        wt: '11'
      },
      {
        lat: '62-00-15-N',
        lon: '09-13-49-E',
        wt: '11'
      },
      {
        lat: '62-00-00-N',
        lon: '05-19-54-E',
        wt: '11'
      },
      {
        lat: '62-00-00-N',
        lon: '04-00-00-W',
        wt: '11'
      },
      {
        lat: '58-33-57-N',
        lon: '04-00-00-W',
        wt: '11'
      },
      {
        lat: '57-12-41-N',
        lon: '04-05-14-W',
        wt: '11'
      },
      {
        lat: '51-34-53-N',
        lon: '00-24-55-W',
        wt: '11'
      },
      {
        lat: '50-24-21-N',
        lon: '04-43-19-W',
        wt: '11'
      }
    ]
  },
  {
    name: 'China Coast',
    data: [
      {
        lat: '39-49-41-N',
        lon: '124-10-06-E',
        wt: '11'
      },
      {
        lat: '37-22-11.64-N',
        lon: '122-57-14.40-E',
        wt: '11'
      },
      {
        lat: '37-21-29.16-N',
        lon: '122-57-00-E',
        wt: '11'
      },
      {
        lat: '36-53-51.36-N',
        lon: '122-48-18-E',
        wt: '11'
      },
      {
        lat: '36-48-25.20-N',
        lon: '122-45-14.40-E',
        wt: '11'
      },
      {
        lat: '36-44-41.28-N',
        lon: '122-40-58.80-E',
        wt: '11'
      },
      {
        lat: '36-35-08.88-N',
        lon: '122-24-36-E',
        wt: '11'
      },
      {
        lat: '35-44-44.16-N',
        lon: '121-03-03.6-E',
        wt: '11'
      },
      {
        lat: '34-59-27.60-N',
        lon: '120-12-57.60-E',
        wt: '11'
      },
      {
        lat: '33-28-46.20-N',
        lon: '121-32-24-E',
        wt: '11'
      },
      {
        lat: '33-06-19.08-N',
        lon: '121-51-14.40-E',
        wt: '11'
      },
      {
        lat: '31-32-08.52-N',
        lon: '122-26-42-E',
        wt: '11'
      },
      {
        lat: '30-49-15.96-N',
        lon: '123-23-31.20-E',
        wt: '11'
      },
      {
        lat: '30-45-51.84-N',
        lon: '123-24-36-E',
        wt: '11'
      },
      {
        lat: '30-05-43.44-N',
        lon: '123-09-28.80-E',
        wt: '11'
      },
      {
        lat: '28-47-31.56-N',
        lon: '122-28-26.40-E',
        wt: '11'
      },
      {
        lat: '28-18-58.32-N',
        lon: '122-07-30-E',
        wt: '11'
      },
      {
        lat: '28-17-01.68-N',
        lon: '122-06-03.6-E',
        wt: '11'
      },
      {
        lat: '27-21-30.96-N',
        lon: '121-19-12-E',
        wt: '11'
      },
      {
        lat: '26-17-32.64-N',
        lon: '120-42-28.80-E',
        wt: '11'
      },
      {
        lat: '26-04-01.92-N',
        lon: '120-36-10.80-E',
        wt: '11'
      },
      {
        lat: '25-18-37.08-N',
        lon: '120-06-57.60-E',
        wt: '11'
      },
      {
        lat: '24-49-31.80-N',
        lon: '119-37-26.40-E',
        wt: '11'
      },
      {
        lat: '24-00-54-N',
        lon: '118-23-16.80-E',
        wt: '11'
      },
      {
        lat: '23-23-16.44-N',
        lon: '117-50-31.20-E',
        wt: '11'
      },
      {
        lat: '23-03-05.40-N',
        lon: '117-22-26.40-E',
        wt: '11'
      },
      {
        lat: '23-01-32.88-N',
        lon: '117-19-51.60-E',
        wt: '11'
      },
      {
        lat: '22-45-05.04-N',
        lon: '116-34-55.20-E',
        wt: '11'
      },
      {
        lat: '22-08-03.12-N',
        lon: '115-13-01.20-E',
        wt: '11'
      },
      {
        lat: '21-37-02.64-N',
        lon: '114-02-09.6-E',
        wt: '11'
      },
      {
        lat: '21-22-25.68-N',
        lon: '112-50-52.80-E',
        wt: '11'
      },
      {
        lat: '21-17-12.48-N',
        lon: '112-29-20.40-E',
        wt: '11'
      },
      {
        lat: '19-51-57.96-N',
        lon: '111-27-00-E',
        wt: '11'
      },
      {
        lat: '19-46-54.84-N',
        lon: '111-23-42-E',
        wt: '11'
      },
      {
        lat: '18-31-10.56-N',
        lon: '110-38-56.40-E',
        wt: '11'
      },
      {
        lat: '18-30-24.12-N',
        lon: '110-37-40.80-E',
        wt: '11'
      },
      {
        lat: '18-16-00.84-N',
        lon: '110-15-07.20-E',
        wt: '11'
      },
      {
        lat: '18-12-45.36-N',
        lon: '110-09-25.20-E',
        wt: '11'
      },
      {
        lat: '17-59-03.12-N',
        lon: '109-45-32.40-E',
        wt: '11'
      },
      {
        lat: '17-59-03.48-N',
        lon: '109-43-04.80-E',
        wt: '11'
      },
      {
        lat: '17-57-18.36-N',
        lon: '109-34-26.40-E',
        wt: '11'
      },
      {
        lat: '18-03-10.80-N',
        lon: '109-03-39.60-E',
        wt: '11'
      },
      {
        lat: '18-08-58.56-N',
        lon: '108-50-42-E',
        wt: '11'
      },
      {
        lat: '18-21-07.92-N',
        lon: '108-33-07.20-E',
        wt: '11'
      },
      {
        lat: '18-22-30-N',
        lon: '108-31-40.80-E',
        wt: '11'
      },
      {
        lat: '18-23-10.32-N',
        lon: '108-31-08.40-E',
        wt: '11'
      },
      {
        lat: '18-25-34.68-N',
        lon: '108-28-44.40-E',
        wt: '11'
      },
      {
        lat: '18-49-13.44-N',
        lon: '108-24-46.80-E',
        wt: '11'
      },
      {
        lat: '19-12-47.16-N',
        lon: '108-23-20.40-E',
        wt: '11'
      },
      {
        lat: '20-24-05-N',
        lon: '108-22-45-E',
        wt: '11'
      },
      {
        lat: '21-12-35-N',
        lon: '108-12-31-E',
        wt: '11'
      },
      {
        lat: '21-16-32-N',
        lon: '108-08-05-E',
        wt: '11'
      },
      {
        lat: '21-27-08.20-N',
        lon: '108-05-43.70-E',
        wt: '11'
      },
      {
        lat: '21-27-23.10-N',
        lon: '108-05-38.80-E',
        wt: '11'
      },
      {
        lat: '21-27-28.20-N',
        lon: '108-05-39.90-E',
        wt: '11'
      },
      {
        lat: '21-27-39.50-N',
        lon: '108-05-51.5-E',
        wt: '11'
      },
      {
        lat: '21-27-50.10-N',
        lon: '108-05-57.7-E',
        wt: '11'
      },
      {
        lat: '21-28-01.70-N',
        lon: '108-06-01.60-E',
        wt: '11'
      },
      {
        lat: '21-28-12.50-N',
        lon: '108-06-04.30-E',
        wt: '11'
      },
      {
        lat: '21-28-12.50-N',
        lon: '108-06-04.30-E',
        wt: '11'
      },
      {
        lat: '21-32-55-N',
        lon: '108-01-52-E',
        wt: '11'
      },
      {
        lat: '43-27-24-N',
        lon: '107-47-16-E',
        wt: '11'
      },
      {
        lat: '44-06-53-N',
        lon: '120-54-8-E',
        wt: '11'
      },
      {
        lat: '39-49-41-N',
        lon: '124-10-06-E',
        wt: '11'
      }
    ]
  }
]
var ecaPolyArrs = []
var pgnArr = []

// 创建ECA的边线
var dealEcaPolyArr = async function () {
  ecaPolyArrs = []
  for (const o of ecaPolysArr) {
    await ecaPolyArrs.push(buildECAPolyData(o.data))
  }
  return ecaPolyArrs
}

// 创建ECA区域
var dealEcaAreaArr = async function () {
  pgnArr = []
  for (const a of ecaAreaArrs) {
    await pgnArr.push(buildECAPolyData(a.data))
  }
  return pgnArr
}

function buildECAPolyData (sArr) {
  var ecaArr = []
  for (const n of sArr) {
    const o = new Object()
    o.wt = n.wt
    o.lon = distanceUtil.transLatLng(n.lon)
    o.lat = distanceUtil.transLatLng(n.lat)
    ecaArr.push(o)
  }
  var newEcaArr = distanceUtil.buildLinePoints(ecaArr)
  var arr = []
  esriLoader
    .loadModules(['esri/geometry/support/webMercatorUtils'])
    .then(([webMercatorUtils]) => {
      for (var v of newEcaArr) {
        var p = webMercatorUtils.lngLatToXY(v.lon, v.lat)
        arr.push(p)
      }
    })
    .catch(err => {
      console.log(err)
    })
  return arr
}

async function buildRoutePointsWithECA (ecaArea, routePoints) {
  let arr = []
  const newArr = []
  for (let r = 0; r < routePoints.length; r++) {
    arr = await reBuildRoutePointWithECA(ecaArea, routePoints[r])
    for (const v of arr) {
      newArr.push(v)
    }
  }
  return newArr
}

function reBuildRoutePointWithECA (ecaArea, routePoint) {
  const newArr = []
  const route = routePoint.route
  const copyRoute = _.cloneDeep(route)
  let isEca = false
  let prePoint = null
  let num = 0
  let startIdx = 0
  esriLoader
    .loadModules([
      'esri/geometry/support/webMercatorUtils',
      'esri/geometry/SpatialReference',
      'esri/geometry/Point'
    ])
    .then(([webMercatorUtils, SpatialReference, Point]) => {
      for (let i = 0; i < route.length; i++) {
        const webPoint = webMercatorUtils.lngLatToXY(
          Number(route[i].lon),
          Number(route[i].lat)
        )
        const p = {
          x: webPoint[0],
          y: webPoint[1]
        }
        if ((isInside(ecaArea, p) && !isEca) || (!isInside(ecaArea, p) && isEca)) {
          // 如果转变，说明有交界
          if (i > 0) {
            // 获取交界的点，并加入航线中
            var crossPoint = getCrossPointWithECA(p, prePoint)
            if (crossPoint) {
              const pp = new Point({
                type: 'point',
                spatialReference: new SpatialReference({
                  wkid: 102100
                }),
                x: crossPoint.x,
                y: crossPoint.y
              })
              var o = new Object()
              var latLon = webMercatorUtils.webMercatorToGeographic(pp)
              o.gVal = 0
              o.lat = latLon.y
              o.lon = latLon.x
              o.wt = '1'
              o.wn = 'eca'

              copyRoute.splice(i + num, 0, o) // splice方法会改变原数组
              var arr = copyRoute.slice(startIdx, i + num + 1)
              if (arr) {
                calcRoutePointDistanceVal(arr)
                newArr.push({
                  distance: arr[arr.length - 1].gVal,
                  eca: isEca,
                  route: arr
                })
                startIdx = i + num
                num += 1
              }
            }
          }
          if (isInside(ecaArea, p)) {
            isEca = true
          } else {
            isEca = false
          }
        }
        prePoint = p
      }
      if (startIdx < copyRoute.length - 1) {
        var arr1 = copyRoute.slice(startIdx, copyRoute.length)
        if (arr1) {
          calcRoutePointDistanceVal(arr1)
          newArr.push({
            distance: arr1[arr1.length - 1].gVal,
            eca: isEca,
            route: arr1
          })
        }
      }
    })
    .catch(err => {
      console.log(err)
    })
  return newArr
}

function calcRoutePointDistanceVal (arr) {
  var sum = 0
  for (let i = 0; i < arr.length; i++) {
    if (i == 0) arr[i].gVal = 0
    else {
      arr[i].gVal =
                sum +
                distanceUtil.greatCircleDist(
                  Number(arr[i - 1].lon),
                  Number(arr[i - 1].lat),
                  Number(arr[i].lon),
                  Number(arr[i].lat)
                )
    }
    sum = arr[i].gVal
  }
}

// 获取与ECA区域边线的交点
function getCrossPointWithECA (p1, p2) {
  var prePoint = null
  var currPoint = null
  for (let j = 0; j < ecaPolyArrs.length; j++) {
    var arr = ecaPolyArrs[j]
    for (let i = 0; i < arr.length; i++) {
      currPoint = {
        x: arr[i][0],
        y: arr[i][1]
      }
      if (i > 0) {
        var p = distanceUtil.getCrossPoint(prePoint, currPoint, p1, p2)
        if (p) {
          return {
            x: p.x,
            y: p.y
          }
        }
      }
      prePoint = {
        x: arr[i][0],
        y: arr[i][1]
      }
    }
  }
  return null
}

/**
 * 经纬度转墨卡托
 */
function latLng2WebMercator (lng, lat) {
  var earthRad = 6378137.0
  var x = lng * Math.PI / 180 * earthRad
  var a = lat * Math.PI / 180
  var y = earthRad / 2 * Math.log((1.0 + Math.sin(a)) / (1.0 - Math.sin(a)))
  return [x, y]
}

/**
 * 墨卡托转经纬度
 */
function webMercator2LngLat (x, y) {
  var lng = x / 20037508.34 * 180
  var lat = y / 20037508.34 * 180
  lat = 180 / Math.PI * (2 * Math.atan(Math.exp(lat * Math.PI / 180)) - Math.PI / 2)
  return [lng, lat]
}

/**
 *  用于判断是否在ECA区域
 *  @param area 多边形坐标集合
 *  @param p 点坐标
 *  返回true为真，false为假
 **/
function judgeInEca (area, p) {
  const webPoint = latLng2WebMercator(Number(p.x), Number(p.y))
  return isInside(area, { x: webPoint[0], y: webPoint[1] })
}

/**
 *  判断一个点是否在多边形内部
 *  @param areas 多边形坐标集合
 *  @param point 测试点坐标
 *  返回true为真，false为假
 *  */
function insidePolygon (area, point) {
  /* var x = point[0],
        y = point[1]; */
  var x = point.x
  var y = point.y
  var inside = false
  for (var i = 0, j = area.length - 1; i < area.length; j = i++) {
    var xi = area[i][0]
    var yi = area[i][1]
    var xj = area[j][0]
    var yj = area[j][1]

    var intersect = yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
    if (intersect) inside = !inside
  }
  return inside
}

function isInside (areas, point) {
  const inside = []
  // let p = latLng2WebMercator(point.x, point.y);
  for (let i = 0; i < areas.length; i++) {
    // inside.push(insidePolygon(areas[i], p));
    inside.push(insidePolygon(areas[i], point))
  }
  return inside.includes(true)
}

export default {
  latLng2WebMercator,
  dealEcaPolyArr,
  dealEcaAreaArr,
  getCrossPointWithECA,
  calcRoutePointDistanceVal,
  buildRoutePointsWithECA,
  isInside,
  judgeInEca
}
